import { createSelector } from "reselect";

const getSelected = ({ selected }) => selected;

export default createSelector([getSelected], selected => selected);
